import { Dialog, Text, COLORS } from "@asayinc/component-library";
import { Stack } from "@mui/material";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useSendTabulationReportMutation } from "src/store/tabulation";

interface ICreateTabulationReportDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export function CreateTabulationReportDialog({
  isOpen,
  onClose,
}: ICreateTabulationReportDialogProps) {
  const { id: proxyId } = useParams() as { id: string };
  const [sendReport, { isLoading }] = useSendTabulationReportMutation();

  const onSubmit = () => {
    sendReport({ proxyId })
      .unwrap()
      .then(() => {
        toast.success("Tabulation report requested successfully");
        onClose();
      })
      .catch((e) => {
        toast.error(e?.data?.message || "Failed to request tabulation report");
      });
  };

  return (
    <Dialog
      onClose={onClose}
      open={isOpen}
      fullWidth
      title="Ad-hoc Tabulation Report"
      buttonActions={[
        {
          label: "Cancel",
          onClick: onClose,
          variant: "secondary",
          size: "small",
        },
        {
          label: "Confirm",
          onClick: onSubmit,
          loading: isLoading,
          size: "small",
        },
      ]}
      content={
        <Stack gap={2}>
          <Text variant="body2">
            Are you sure you want to request this tabulation report?
          </Text>
          <Text variant="body3" sx={{ color: COLORS.P_MED_LOW_EMPHASIS }}>
            Note: The standard tabulation report fee applies.
          </Text>
        </Stack>
      }
      ctaOrientation="horizontal"
    />
  );
}
